import React, { useEffect, useState } from "react";
import "./Inbox.css";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Loader from "./components/Loader";
import Home from "./pages/Home";
import Sidebar from "./components/Sidebar";
import Chat from "./pages/Chat";
import { useUsersContext } from "./context/usersContext";
import {getOpenChatCount, isMobile, loadContactsData, showToast} from "../../Common/Appcommon";

// const userPrefersDark =
// 	window.matchMedia &&
// 	window.matchMedia("(prefers-color-scheme: dark)").matches;

function InboxContainer() {
	const {users, loadUsers} = useUsersContext();
	const [appLoaded, setAppLoaded] = useState(false);
	const [startLoadProgress, setStartLoadProgress] = useState(false);

	useEffect(() => {
		//if (userPrefersDark) document.body.classList.add("dark-theme");
		(async () => {
			if(Object.keys(users).length === 0){
				await loadContacts();
			}
		  })();
		  stopLoad();
		  return () => {
			// this now gets called when the component unmounts
		  };
	}, []);

	const stopLoad = () => {
		setStartLoadProgress(true);
		setTimeout(() => setAppLoaded(true), 500);
	};

	const loadContacts = async() => {
		let response = await loadContactsData();
		if(response.issuccess) {
            let contacts = response.data;
			loadUsers(contacts);
			getOpenChatCount(contacts);
        } else if (response.errormsg !== ""){
            showToast(response.errormsg, "top-right","error");
        }
	};
	
	if (!appLoaded) return <Loader done={startLoadProgress} />;
	
	return (
		<div className="inbox">
			<Router>
				<div className="inbox-content">
					{!isMobile() && <Sidebar />}
					<Switch>
						<Route path="/inbox/chat/:id" component={Chat} />
						<Route path="/inbox/" component={Home} />
					</Switch>
				</div>
			</Router>
		</div>
	);
}

export default InboxContainer;
